import React from 'react';
import { NavLink } from 'react-router-dom';
import { formatDataIdAttr } from '../../../core/utils/dataIdFormatter';
import { HdIcon, HdTooltip } from '../../../components';
import { TabProps } from '../../interfaces/secondarySidebar';
import { SecondarySidebarItemTooltip } from '../secondary-sidebar-item-tooltip/SecondarySidebarItemTooltip';

export function SecondarySidebarItem({
  tab,
  expanded
}: {
  tab: TabProps;
  expanded: boolean;
}) {
  return (
    <HdTooltip
      title={
        <SecondarySidebarItemTooltip
          command={tab.shortcut}
          showLabel={!expanded}
          label={tab.label}
        />
      }
      disabled={expanded && !tab.shortcut}
      mode='surface'
      placement='right'
    >
      <NavLink
        to={tab.path || tab.route}
        data-id={formatDataIdAttr(tab.label)}
        className='tab-nav-link'
      >
        <HdIcon
          name={tab.icon}
          className='tab-nav-link-icon'
        />
        {expanded ? (
          <span className='tab-nav-link-text'>
          {tab.label}
        </span>
        ) : null}
      </NavLink>
    </HdTooltip>
  );
}
